import BrandMark from './BrandMark';

export default function LogoIcon() {
  return <BrandMark size={40} gradientId="cl-logo-icon-grad" />;
}
